import { render } from "./RequetesInJeu.vue?vue&type=template&id=61c9cc02"
import script from "./RequetesInJeu.vue?vue&type=script&lang=js"
export * from "./RequetesInJeu.vue?vue&type=script&lang=js"

import "./RequetesInJeu.vue?vue&type=style&index=0&id=61c9cc02&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__